/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_No_MatchesInputs */

const cs_deals_no_matches = /** @type {(inputs: Deals_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný obchod tomu neodpovídá.`)
};

const en_deals_no_matches = /** @type {(inputs: Deals_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deals match this search.`)
};

/**
* | output |
* | --- |
* | "No deals match this search." |
*
* @param {Deals_No_MatchesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_no_matches = /** @type {((inputs?: Deals_No_MatchesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_No_MatchesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_no_matches(inputs)
	return cs_deals_no_matches(inputs)
});